import { gql } from "@apollo/client";

export const GET_TOP_PRODUCTS = gql`
  query GetTopProducts(
    $siteId: SiteID!
    $devices: [String!]!
    $startDate: String!
    $endDate: String!
    $segments: [String!]
    $first: Int!
  ) {
    itemMonitor(
      siteId: $siteId
      devices: $devices
      startDate: $startDate
      endDate: $endDate
      sort: "displays DESC"
      segments: $segments
      first: $first
    ) {
      edges {
        node {
          item {
            id
            name
            absoluteLink
            imgLink
          }
          transactions
          pageviews
          quantity
          revenues
          displays
          usages
          goToPageUsages
          addToCartUsages
        }
      }
    }
  }
`;
